module.exports = __webpack_public_path__ + "fonts/qtzain_reguar_final.a7f59af0.woff2";